import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { SortableTable } from './services-table-helper';


@Injectable({
  providedIn: 'root'
})
export class NotaControlCppcService extends SortableTable<any> {
  private baseUrl = environment.API_URL;

  constructor(
    private http: HttpClient
  ) {
    super();
  }

  getAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/cantariri/nota-control-cppc/`,
      req_params
    );
  }

  listAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/cantariri/nota-control-cppc/list/`,
      req_params
    ).pipe(
      map((response: any) => {
        this.totalRecords = response.count;
        this.paginate();

        return response;
      }));
  }

  saveAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/cantariri/nota-control-cppc/save/`,
      req_params
    );
  }

  deleteAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/cantariri/nota-control-cppc/delete/`,
      req_params
    );
  }

  animaleAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/cantariri/nota-control-cppc/animale/`,
      req_params
    );
  }

  updateApreciereFenotipicaAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/cantariri/nota-control-cppc/update-apreciere-fenotipica/`,
      req_params
    );
  }

  downloadAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/cantariri/nota-control-cppc/download/`,
      req_params,
      {
        responseType: 'blob'
      }
    );
  }

  private paginate(): void {
    this._state.startIndex = (this._state.page - 1) * this.pageSize + 1;
    this._state.endIndex = Number(this.pageSize) + Number(this._state.startIndex - 1);

    if (this._state.endIndex > this.totalRecords) {
      this._state.endIndex = this.totalRecords;
    }
  }
}
